import "core-js/modules/es.object.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { streamerMarketRestrictionsAdd, streamerMarketRestrictionsCancel } from '@/api/gmToolNew/gmToolNew';
import { gmToolNew, gmToolNewCom, gmToolNewPage } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom, gmToolNewPage],
  data: function data() {
    var _this = this;

    var validateuids = function validateuids(rule, value, callback) {
      var regex = /[\u4e00-\u9fa5，]/;

      if (regex.test(value) || !value) {
        callback(new Error(_this.$t('playerIdIncorrectWithComma')));
      } else {
        callback();
      }
    };

    return {
      dialogShow: false,
      paramsData: {
        uid: '',
        server_id: '',
        typeChange: 1
      },
      rules: {
        uid: [{
          required: true,
          validator: validateuids,
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(type) {
      this.paramsData.typeChange = type == 1 ? 1 : 2;
      this.dialogShow = true;
      this.paramsData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      this.paramsData = {
        uid: '',
        server_id: ""
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      if (!this.paramsData.server_id) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.paramsData.typeChange == 1 ? streamerMarketRestrictionsAdd : streamerMarketRestrictionsCancel;
          reqFn(_this2.paramsData).then(function (res) {
            if (res.status == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('change');
            }
          }).finally(function () {
            _this2.issubmit = false;
          });
        }
      });
    }
  }
};